export class SsoFeature {
	enabled: boolean;
    logoutByClient?: boolean;
	logoutUrl: string;
	redirect = {
		enabled: false,
		endpoint: ''
	};

	constructor(feature: Partial<SsoFeature> = null) {
		if (feature) {
			Object.keys(feature).forEach(key => this[key] = feature[key]);
		}
	}
}